import {rootApiGroup} from '@integraciones_doc24/wehealthy-api';
import {ApiErrors} from '@integraciones_doc24/wehealthy-api/types/errors';
import {getLandingConfigEndpoint} from '@integraciones_doc24/wehealthy-api/root/content/getLandingConfig';
import {initApiConsumer} from '@urpi/consumer';
import {createLandingFastRegistrationDynamicLinkEndpoint} from '@integraciones_doc24/wehealthy-api/root/user/fastRegistration/landingDynamicLink';
import {getBackEnd} from './backEndUrl';

const backendUrl = getBackEnd();

const apiConsumer = initApiConsumer<ApiErrors.All>(
  `${backendUrl}/api`,
  rootApiGroup,
);

const getDynamicLink = apiConsumer(
  createLandingFastRegistrationDynamicLinkEndpoint,
);
const getLandingConfigEP = apiConsumer(getLandingConfigEndpoint);

export const formAction = async (
  fieldsnValues: object,
  landingId: string,
  brandId: string,
  planSeleccionado: string,
  sendEmail: boolean,
) => {
  const formDatareceived = await getDynamicLink({
    body: {
      landingId,
      brandId,
      destinationPlanId: planSeleccionado,
      formValues: fieldsnValues,
      sendEmail: sendEmail,
    },
  });
  return formDatareceived.data;
};

export const getLandingConfig = async () => {
  const landingConfig = await getLandingConfigEP({
    //routeParams: {brandId},
    query: {url: window.location.href},
  });
  return landingConfig.data;
  //return landingConfig;
};
